import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconDirective } from '@coreui/icons-angular';
import { AlertsPanelService } from '../../services/alerts-panel.service';

@Component({
  selector: 'app-alerts-panel',
  templateUrl: './alerts-panel.component.html',
  styleUrls: ['./alerts-panel.component.scss'],
  standalone: true,
  imports: [CommonModule, IconDirective],
})
export class AlertsPanelComponent {
  readonly svc = inject(AlertsPanelService);
}
